@if (value?.aiAnalysisType) {
    <div class="agpr-coverageInsightsForm">
        <!-- re-add when we do custom -->
        @if (value?.aiAnalysisType !== coverageInsightTypes.CUSTOM) {
            @if (value?.aiAnalysisType === coverageInsightTypes.EXECUTIVE_SUMMARY) {
                <div class="agpr-coverageInsightsForm-spacing">
                    <agpr-text-input
                        [maxLength]="255"
                        [id]="'coverage_insights_form_focus'"
                        [label]="'Briefings.analysis.analysisFocus'"
                        [placeholder]="'Briefings.analysis.analysisFocus.placeholder'"
                        [tooltip]="'Briefings.analysis.analysisFocus.tooltip'"
                        [(ngModel)]="value.focus"
                        (ngModelChange)="emitValue()"
                    ></agpr-text-input>
                </div>
                <div class="agpr-coverageInsightsForm-spacing">
                    <agpr-dropdown
                        [id]="'coverage_insights_form_length'"
                        label="Common.dialog.aiHelper.pressReleaseLength"
                        [options]="lengthOptions"
                        [(ngModel)]="selectedLengthOption"
                        [infoCircleTooltip]="'Common.dialog.aiHelper.pressReleaseLengthTooltip'"
                        (ngModelChange)="emitValue()"
                    >
                    </agpr-dropdown>
                    @if (!selectedLengthOption) {
                        <agpr-form-message>
                            {{ 'Briefings.analysis.errors.mustSelectLength' | localize }}
                        </agpr-form-message>
                    }
                </div>
            }

            @if (value?.aiAnalysisType === coverageInsightTypes.KEY_TAKEAWAYS) {
                <div class="agpr-coverageInsightsForm-spacing">
                    <agpr-text-input
                        [maxLength]="255"
                        [id]="'coverage_insights_form_focus'"
                        [label]="'Briefings.analysis.analysisFocus'"
                        [placeholder]="'Briefings.analysis.analysisFocus.placeholder'"
                        [tooltip]="'Briefings.analysis.analysisFocus.tooltip'"
                        [(ngModel)]="value.focus"
                        (ngModelChange)="emitValue()"
                    ></agpr-text-input>
                </div>
                <div class="agpr-coverageInsightsForm-spacing">
                    <agpr-dropdown
                        [id]="'coverage_insights_form_takeaways'"
                        class="agpr-userProfile-gridItem"
                        label="Briefings.analysis.numOfTakeaways"
                        [options]="keyTakeawayOptions"
                        [bindToValue]="true"
                        [(ngModel)]="value.numOfTakeaways"
                        (ngModelChange)="emitValue()"
                    >
                    </agpr-dropdown>
                </div>
            }
            @if (value?.aiAnalysisType === coverageInsightTypes.BRAND_IMPACT) {
                <div class="agpr-coverageInsightsForm-spacing">
                    <agpr-text-input
                        [id]="'coverage_insights_form_brand'"
                        [label]="'Briefings.analysis.brand'"
                        [placeholder]="'Briefings.analysis.brand.placeholder'"
                        [tooltip]="'Briefings.analysis.brand.tooltip'"
                        [(ngModel)]="value.brand"
                        (ngModelChange)="emitValue()"
                    ></agpr-text-input>
                    @if (!value.brand) {
                        <agpr-form-message>
                            {{ 'Briefings.analysis.errors.mustAddBrand' | localize }}
                        </agpr-form-message>
                    }
                </div>
            }
            @if (value?.aiAnalysisType === coverageInsightTypes.SENTIMENT_OPINION) {
                <div class="agpr-coverageInsightsForm-spacing">
                    <agpr-text-input
                        [id]="'coverage_insights_form_context'"
                        [label]="'Briefings.analysis.context'"
                        [placeholder]="'Briefings.analysis.context.placeholder'"
                        [(ngModel)]="value.context"
                        (ngModelChange)="emitValue()"
                    ></agpr-text-input>
                </div>
                <div class="agpr-coverageInsightsForm-spacing">
                    <agpr-dropdown
                        [id]="'coverage_insights_sentiment_opinion_form_length'"
                        label="Common.dialog.aiHelper.pressReleaseLength"
                        [options]="lengthOptions"
                        [(ngModel)]="selectedLengthOption"
                        [infoCircleTooltip]="'Common.dialog.aiHelper.sentimentOpinionLengthTooltip'"
                        (ngModelChange)="emitValue()"
                    >
                    </agpr-dropdown>
                    @if (!selectedLengthOption) {
                        <agpr-form-message [id]="'coverage_insights_sentiment_opinion_form_length_message'">
                            {{ 'Briefings.analysis.errors.mustSelectLength' | localize }}
                        </agpr-form-message>
                    }
                </div>
            }

            @if (value?.aiAnalysisType === coverageInsightTypes.TOP_NARRATIVES) {
                <div class="agpr-coverageInsightsForm-spacing">
                    <agpr-text-input
                        [maxLength]="255"
                        [id]="'coverage_insights_form_focus'"
                        [label]="'Briefings.analysis.analysisFocus'"
                        [placeholder]="'Briefings.analysis.analysisFocus.placeholder'"
                        [tooltip]="'Briefings.analysis.analysisFocus.tooltip'"
                        [(ngModel)]="value.focus"
                        (ngModelChange)="emitValue()"
                    ></agpr-text-input>
                </div>
                <div class="agpr-coverageInsightsForm-spacing">
                    <agpr-dropdown
                        [id]="'coverage_insights_form_takeaways'"
                        class="agpr-userProfile-gridItem"
                        label="Briefings.analysis.numOfTakeaways"
                        [options]="keyTakeawayOptions"
                        [bindToValue]="true"
                        [(ngModel)]="value.numOfTakeaways"
                        (ngModelChange)="emitValue()"
                    >
                    </agpr-dropdown>
                </div>

            }

            @if (value?.aiAnalysisType === coverageInsightTypes.COVERAGE_SURGE_INSIGHT) {
                <div class="agpr-coverageInsightsForm-spacing">
                    <agpr-text-input
                        [maxLength]="255"
                        [id]="'coverage_insights_form_focus'"
                        [label]="'Briefings.analysis.analysisFocus'"
                        [placeholder]="'Briefings.analysis.analysisFocus.placeholder'"
                        [tooltip]="'Briefings.analysis.analysisFocus.tooltip'"
                        [(ngModel)]="value.focus"
                        (ngModelChange)="emitValue()"
                    ></agpr-text-input>
                </div>
                <div class="agpr-coverageInsightsForm-indent">
                    <agpr-checkbox
                        [id]="'coverage_insights_form_includeThemes'"
                        label="Briefings.analysis.includeThemes"
                        [binary]="true"
                        [(ngModel)]="value.includeThemes"
                        (ngModelChange)="emitValue()"
                    ></agpr-checkbox>
                </div>
                <div class="agpr-coverageInsightsForm-indent">
                    <agpr-checkbox
                        [id]="'coverage_insights_form_includeSentiment'"
                        label="Briefings.analysis.includeSentiment"
                        [binary]="true"
                        [(ngModel)]="value.includeSentiment"
                        (ngModelChange)="emitValue()"
                    ></agpr-checkbox>
                </div>
                <div class="agpr-coverageInsightsForm-indent">
                    <agpr-checkbox
                        [id]="'coverage_insights_form_includeStrategy'"
                        label="Briefings.analysis.includeStrategy"
                        [binary]="true"
                        [(ngModel)]="value.includeStrategy"
                        (ngModelChange)="emitValue()"
                    ></agpr-checkbox>
                </div>
            }

            <div class="agpr-coverageInsightsForm-spacing">
                <agpr-dropdown
                    [id]="'coverage_insights_form_language'"
                    label="Common.dialog.aiHelper.language"
                    [options]="promptLanguageOptions"
                    [(ngModel)]="selectedLanguageOption"
                    [infoCircleTooltip]="'Common.dialog.aiHelper.languageTooltip'"
                    (ngModelChange)="emitValue()"
                >
                </agpr-dropdown>
                @if (!selectedLanguageOption) {
                    <agpr-form-message>
                        {{ 'Briefings.analysis.errors.mustSelectLanguage' | localize }}
                    </agpr-form-message>
                }
            </div>

            @if (value?.aiAnalysisType === coverageInsightTypes.TOP_NARRATIVES) {
                <div class="agpr-coverageInsightsForm-spacing">
                    <agpr-checkbox
                        [id]="'coverage_insights_form_includeOutletReference'"
                        label="Briefings.analysis.includeOutletReference"
                        [binary]="true"
                        [(ngModel)]="value.includeOutletReference"
                        (ngModelChange)="emitValue()"
                    ></agpr-checkbox>
                </div>
            }

            @if (value?.aiAnalysisType === coverageInsightTypes.EXECUTIVE_SUMMARY) {
                <div class="agpr-coverageInsightsForm-spacing">
                    <agpr-checkbox
                        [id]="'coverage_insights_form_includeKeyTakeaways'"
                        label="Briefings.analysis.includeKeyTakeaways"
                        [binary]="true"
                        [(ngModel)]="includeKeyTakeaways"
                        (ngModelChange)="emitValue()"
                    ></agpr-checkbox>
                </div>

                @if (includeKeyTakeaways) {
                    <div class="agpr-coverageInsightsForm-indent">
                        <agpr-text-input
                            [id]="'coverage_insights_form_keyTakeawayHeading'"
                            [label]="'Briefings.analysis.keyTakeawayHeading'"
                            [placeholder]="'Briefings.analysis.keyTakeawayHeading.placeholder'"
                            [(ngModel)]="keyTakeawayHeading"
                            (ngModelChange)="emitValue()"
                        ></agpr-text-input>
                    </div>
                }
            }

        <!-- re-add when we do custom -->
        } @else if (customInsight) {
            <div class="agpr-coverageInsightsForm-spacing">
                <agpr-text-input
                    [id]="'coverage_insights_form_name'"
                    [label]="'Briefings.analysis.customAnalysisName'"
                    [maxLength]="64"
                    [placeholder]="'Briefings.analysis.customAnalysisName.placeholder'"
                    [(ngModel)]="customInsight.name"
                    [required]="true"
                    (ngModelChange)="handleCustom()"
                ></agpr-text-input>
            </div>
            <div class="agpr-coverageInsightsForm-spacingBig">
                <agpr-textarea-input
                    [id]="'coverage_insights_form_analysisPrompt'"
                    [label]="'Briefings.analysis.analysisPrompt'"
                    [placeholder]="'Briefings.analysis.analysisPrompt.placeholder'"
                    [tooltip]="'Briefings.analysis.analysisPrompt.tooltip'"
                    ariaLabel="Briefings.analysis.analysisPrompt.placeholder"
                    [(ngModel)]="customInsight.prompt"
                    [required]="true"
                    [rows]="6"
                    [icon]="'fa-kit-duotone fa-agpr-ai-generic'"
                    (ngModelChange)="handleCustom()"
                ></agpr-textarea-input>
            </div>
        }
    </div>
}
